import FetchFailedPage from './FetchFailedPage.page';

export default FetchFailedPage;